<template>
  <div class="c-floating">
    <ul class="floating-wrap">
      <li
        v-if="
          template.meeting.interact_question_icon.display.value &&
            tenantPermInfo.isDisabledVoteQueDown == 2
        "
      >
        <a @click="questionary()">
          <span class="items-text">调查问卷</span>
          <span class="icon icontemp volume"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_vote_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2
        "
      >
        <a @click="getVote()">
          <span class="items-text">投票</span>
          <span class="icon icontemp storied"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_luckdraw_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2
        "
      >
        <a @click="getLuckyDrawRoster()">
          <span class="items-text">幸运抽奖</span>
          <span class="icon icontemp lottery"></span>
        </a>
      </li>
      <li
        v-if="
          template.meeting.interact_file_icon.display.value &&
            tenantPermInfo.isDisabledVoteQueDown == 2
        "
      >
        <a @click="file()">
          <span class="items-text">文件下载</span>
          <span class="icon icontemp form"></span>
        </a>
      </li>
    </ul>
    <div
      :class="['new-floating', { close: !isOpen }]"
      v-if="
        (template.meeting.interact_question_icon.display.value &&
          tenantPermInfo.isDisabledVoteQueDown == 2) ||
          (template.meeting.interact_vote_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2) ||
          (template.meeting.interact_file_icon.display.value &&
            tenantPermInfo.isDisabledVoteQueDown == 2) ||
          (template.meeting.interact_luckdraw_icon.display.value &&
            tenantPermInfo.isDisabledLuckDraw == 2)
      "
    >
      <div class="floating-btn" @click="isOpen = !isOpen">
        <img
          :src="
            isOpen
              ? require('../../assets/images/floating/close.png')
              : require('../../assets/images/floating/open.png')
          "
          alt="btn"
        />
      </div>
      <div class="floating-content">
        <div
          class="floating-item"
          v-if="
            template.meeting.interact_question_icon.display.value &&
              tenantPermInfo.isDisabledVoteQueDown == 2
          "
        >
          <!-- 调查问卷 -->
          <a @click="questionary()">
            <img
              :src="require('../../assets/images/floating/questionary.png')"
              alt="question"
            />
          </a>
        </div>
        <div
          class="floating-item"
          v-if="
            template.meeting.interact_vote_icon.display.value &&
              tenantPermInfo.isDisabledLuckDraw == 2
          "
        >
          <!-- 投票 -->
          <a @click="getVote()">
            <img
              :src="require('../../assets/images/floating/vote.png')"
              alt="vote"
            />
          </a>
        </div>
        <div
          class="floating-item"
          v-if="
            template.meeting.interact_luckdraw_icon.display.value &&
              tenantPermInfo.isDisabledLuckDraw == 2
          "
        >
          <!-- 幸运抽奖 -->
          <a @click="getLuckyDrawRoster()">
            <img
              :src="require('../../assets/images/floating/gift.png')"
              alt="luckyDraw"
            />
          </a>
        </div>
        <div
          class="floating-item floating-item3"
          v-if="
            template.meeting.interact_file_icon.display.value &&
              tenantPermInfo.isDisabledVoteQueDown == 2
          "
        >
          <!-- 文件下载 -->
          <a @click="file()">
            <img
              :src="require('../../assets/images/floating/file.png')"
              alt="file"
            />
          </a>
        </div>
        <div class="floating-item2">
          <!-- 返回顶部 -->
          <a @click="scrollTop">
            <img
              :src="require('../../assets/images/floating/top.png')"
              alt="top"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
import { mixinsTemplate } from "../../common/mixinsTemplate";
export default {
  name: "Suspension",
  mixins: [mixinsTemplate],
  data() {
    return {
      isOpen: true
    };
  },
  created() {},
  methods: {
    getLuckyDrawRoster() {
      $subscriber.emit("getLuckyDrawRoster");
    },
    getVote() {
      $subscriber.emit("clickOnVote", "shoudong");
    },
    file() {
      $subscriber.emit("showFile");
    },
    questionary() {
      $subscriber.emit("showQuestion", "shoudong");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped></style>
